import { brokerCasesApi } from '@api/brokerCases/brokerCasesApi';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DocumentReview, DocumentReviewStatus, DocumentReviewType } from '@api/brokerCases/types';

export const DOCUMENT_REVIEWS_QUERY_KEY = 'broker-case-document-reviews';

export function useDocumentReviews(
  caseId: string,
  individualId: string,
  status: DocumentReviewStatus,
  type: DocumentReviewType,
): UseQueryResult<DocumentReview[]> {
  return useQuery({
    queryKey: [DOCUMENT_REVIEWS_QUERY_KEY, caseId, individualId, status],
    queryFn: () => brokerCasesApi.getDocumentReviews(caseId, individualId, status, type),
    refetchInterval: 2500,
    enabled: Boolean(caseId && individualId),
  });
}
